import FormLabel from "./formLabel";
import type { LabelProps } from "./formLabel";
import { Observer } from "mobx-react-lite";
import React from "react";
import { bound } from "@frui.ts/helpers/dist";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import type { IBindingProps } from "@frui.ts/views";
import { BindingComponent } from "@frui.ts/views";
import type { FormLabelProps } from "react-bootstrap";
import Tooltip from "@edaz/edazkit/Tooltip";

export interface LabelWithTooltipProps extends LabelProps {
  tooltipText: string;
  withoutFormLabel?: boolean;
}

export class FormLabelWithTooltip<TTarget> extends BindingComponent<
  TTarget,
  IBindingProps<TTarget> & LabelWithTooltipProps & FormLabelProps
> {
  static defaultProps = {
    required: "autoDetect",
  };

  @bound
  protected renderInner() {
    const { children, property } = this.props;
    const { tooltipText, ...rest } = this.props as { tooltipText: string };
    const { withoutFormLabel } = this.props;

    const tooltipId = `${property}-tooltip`;

    return (
      <>
        {withoutFormLabel ? <>{children}</> : <FormLabel {...rest}>{children}</FormLabel>}
        <Tooltip id={tooltipId} trigger={["hover", "focus"]} placement="right" tooltip={tooltipText}>
          <span className="px-2">
            <Icon className="cursor-pointer" icon={IconType.MiniInfo} width={16} height={16} />
          </span>
        </Tooltip>
      </>
    );
  }

  render() {
    return <Observer render={this.renderInner} />;
  }
}

export default FormLabel;
